export class FormInputBase<T> {
  value: T;
  key: string;
  label: string;
  required: boolean;
  order: number;
  controlType: string;
  type: string;
  placeholder: string;
  className: string;
  boxLevel: string;
  section: number;
  isPercentage: boolean;
  isNotDecimal: boolean;
  isMonth: boolean;
  errorMessages: IErrorMessages;
  options: { key: any, value: any }[];

  constructor(options: {
    value?: T;
    key?: string;
    label?: string;
    required?: boolean;
    order?: number;
    controlType?: string;
    type?: string;
    placeholder?: string;
    className?: string;
    boxLevel?: string;
    section?: number;
    isPercentage?: boolean;
    isNotDecimal?: boolean;
    isMonth?: boolean;
    errorMessages?: IErrorMessages;
    options?: { key: any, value: any }[];
  } = {}) {
    this.value = options.value;
    this.key = options.key || '';
    this.label = options.label || '';
    this.required = !!options.required;
    this.order = options.order === undefined ? 1 : options.order;
    this.controlType = options.controlType || '';
    this.type = options.type || '';
    this.placeholder = options.placeholder || '';
    this.className = options.className || '';
    this.boxLevel = options.boxLevel || '';
    this.section = options.section || null;
    this.isPercentage = options.isPercentage || false;
    this.isNotDecimal = options.isNotDecimal || false;
    this.isMonth = options.isMonth || false;
    this.errorMessages = options.errorMessages || {} as IErrorMessages;
    this.options = options.options || [];
  }
}
export class TextboxInput extends FormInputBase<string> {
  controlType = 'textbox';
}

export class DropdownInput extends FormInputBase<string> {
  controlType = 'dropdown';
}

export class DatepickerInput extends FormInputBase<string> {
  controlType = 'datepicker';
}

export interface IErrorMessages {
  required: string;
}
